export const base_shirt_data = {
	id: 'default',
	title: 'ค่าเริ่มต้น',
	shirt_url: './images/shirt_type/shirt_style/default.png',
	collar_url: './images/shirt_type/shirt_style/default.png',
	placket_url: './images/shirt_type/shirt_style/default.png',
	sleeve_url: './images/shirt_type/shirt_style/default.png',
	pocket_url: './images/shirt_type/shirt_style/default.png',
}